class FlickitySlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id="Flickity-Slider"]');
    this.sliderItems = this.querySelectorAll('[id^="Flickity-Slide"]');
    this.enableFlickity(this.slider);
  }

  enableFlickity(slider) {
    console.log("Flickity start")
    var prevNextButtons = false;
    var pageDots = false;
    if (slider.hasAttribute('prevNextButtons')) {
      prevNextButtons = true;
    }
    if (slider.hasAttribute('pageDots')) {
      pageDots = true;
    }

    var flkty = new Flickity(slider, {
      cellAlign: 'center',
      draggable: true,
      contain: true,
      wrapAround: false,
      autoPlay: false,
      pauseAutoPlayOnHover: false,
      groupCells: true,
      pageDots: pageDots,
      prevNextButtons: prevNextButtons,
      imagesLoaded: true,
    });

    if (this.querySelector('.Zutatenliste')) {
      var ZL = this.querySelector('.Zutatenliste');

      const myObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          flkty.resize();
        });
      });

      myObserver.observe(ZL);
    }

    if (this.querySelector('.key_ingredients')) {
      
      var KI = this.querySelector('.key_ingredients')
      const myObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          this.unsetSameHeight();
          flkty.resize();
          this.setSameHeight();
        });
      });

      myObserver.observe(KI);
    }

    if (this.querySelector('[id="Flickity-Nav"]')) {
      this.enableNav(flkty);
    }

    window.addEventListener('load', function () {
      flkty.reloadCells();
      flkty.resize();
      
    });
  }

  enableNav(flkty) {
    var buttonGroup = this.querySelector('[id="Flickity-Nav"]');
    var buttons = buttonGroup.querySelectorAll('.Content_Slider_Nav_button');
    buttons = fizzyUIUtils.makeArray(buttons);

    buttonGroup.addEventListener('click', function (event) {
      if (!matchesSelector(event.target, '.Content_Slider_Nav_button')) {
        return;
      }
      var index = buttons.indexOf(event.target);
      flkty.select(index);
    });

    flkty.on('change', function (index) {
      var l_active = buttonGroup.querySelector('.active');
      l_active.classList.remove('active');
      buttons[index].classList.add('active');
    });
  }

  setSameHeight() {
    this.sliderItems.forEach((slide) => {
      slide.classList.add('fullheight');
    });
    this.querySelectorAll('.ass_wrapper').forEach((wrapper) => {
      wrapper.classList.add('fullheight');
    });
  }

  unsetSameHeight() {
    this.sliderItems.forEach((slide) => {
      slide.classList.remove('fullheight');
    });
    this.querySelectorAll('.ass_wrapper').forEach((wrapper) => {
      wrapper.classList.remove('fullheight');
    });
  }

}

customElements.define('flickity-slider', FlickitySlider);
